export default __webpack_public_path__ + "static/media/118.ed4a9ccc.jpeg";